"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/ParticipantsPicker/ResultsList/ResultsSection/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _EntityItem = require('./EntityItem'); var _EntityItem2 = _interopRequireDefault(_EntityItem);








const ResultsSection = ({
  title,
  entitiesList,
  onSelectEntity,
  getDisabled,
}) => {
  if (!entitiesList.length) return null

  return (
    _react2.default.createElement('div', { className: "participants-picker--results-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}}
      ,  title && (
        _react2.default.createElement('h6', { className: "participants-picker--results-section--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}
          ,  title 
        )
      )
      ,  entitiesList.map(e => (
        _react2.default.createElement(_EntityItem2.default, {
          key: e.entityKey,
          entity: e,
          onSelectEntity: onSelectEntity,
          isDisabled: _optionalChain([getDisabled, 'optionalCall', _ => _(e)]), __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}}
        )
      ))
    )
  )
}

exports. default = ResultsSection
